import React from "react";
import { translate } from "utlis/translations/i18n";

const ImageCardWithAttributes = ({
  channelName,
  attributes,
  ressource,
  result,
  selectedName,
  votes,
}) => {
  const selectedNameScore = votes.find(
    (vote) => vote.name === channelName && vote.voter === selectedName
  );

  // Regroupement des votes par channelName
  const votesByChannel = votes.reduce((groups, vote) => {
    if (!groups[vote.name]) {
      groups[vote.name] = [];
    }
    groups[vote.name].push(vote);
    return groups;
  }, {});

  // Création d'une copie de result pour pouvoir le modifier
  let resultCopy = { ...result };

  Object.keys(votesByChannel).forEach((channelName) => {
    const votes = votesByChannel[channelName];

    // Afficher l'écart type si il y a plus d'un vote
    if (votes.length > 1) {
      const average =
        votes.reduce((sum, vote) => sum + vote.score, 0) / votes.length;
      const sumOfSquares = votes.reduce(
        (sum, vote) => sum + Math.pow(vote.score - average, 2),
        0
      );
      const standardDeviation = Math.sqrt(sumOfSquares / votes.length);

      if (resultCopy[channelName]) {
        resultCopy[channelName].standardDeviation = standardDeviation;
      }
    }
  });

  return (
    <div className="attributes-results-card">
      <h3>{channelName}</h3>
      <h3>
        {translate("results.averageScore")}: {result[channelName].average}%
      </h3>
      {resultCopy[channelName] && resultCopy[channelName].standardDeviation && (
        <h3 style={{ display: "flex", justifyContent: "center" }}>
          {translate("standardDeviation")} :{" "}
          {resultCopy[channelName].standardDeviation.toFixed(2)}%
        </h3>
      )}
      {attributes &&
        attributes[0] &&
        attributes.map((attribute, index) => (
          <div
            key={index}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>{attribute.name}:&nbsp;</div>
            <div>
              {Number(
                (ressource.attributes[index].quantity *
                  result[channelName].average) /
                  100
              ).toFixed(2)}
              &nbsp;
              {attribute.unit}
            </div>
          </div>
        ))}
      {selectedName && selectedName !== "" && selectedNameScore && (
        <h3>
          {translate("reviewFrom")} {selectedName}: {selectedNameScore.score} %
        </h3>
      )}
      <br />
    </div>
  );
};

export default ImageCardWithAttributes;
